import { useI18n } from 'hooks/useI18n';
import { UIOfferWherePerk } from 'interfaces/ui/ui-offer-where-perk';
import JobOfferSubsection from '../JobOfferSubsection';
import {
  StyledWherePerks,
  StyledWherePerksItem,
  StyledWherePerksItemIcon,
  StyledWherePerksItemTitle
} from './WherePerks.styled';

const WherePerks = ({ officePerks }: { officePerks: UIOfferWherePerk[] }) => {
  const { t } = useI18n('job-offer');

  return (
    <JobOfferSubsection title={t('where.interesting')}>
      <StyledWherePerks>
        {officePerks.map((perk, i) => (
          <StyledWherePerksItem key={i}>
            <StyledWherePerksItemIcon src={perk.type.icon} />

            <StyledWherePerksItemTitle>
              {perk.type.text}
            </StyledWherePerksItemTitle>

            <span>{perk.text}</span>
          </StyledWherePerksItem>
        ))}
      </StyledWherePerks>
    </JobOfferSubsection>
  );
};

export default WherePerks;
